import styles from './LoadingLogo.module.css';

const LoadingLogo = () => {
    return ( 
<div className={styles.loading}>
    <img className={styles.logo} src="/logo.png" alt="Logo" />
</div>
     );
}
 
export default LoadingLogo;